import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const SupportPage = () => {
  useEffect(() => {
    document.title = "Support | Business Studio Suite";
  }, []);

  return (
    <main className="min-h-screen bg-[#f7f4ee] px-4 py-8 text-slate-900" data-testid="support-page">
      <div className="mx-auto max-w-3xl">
        <header className="mb-6 flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#9c742e]">Business Studio Suite</p>
            <h1 className="mt-1 font-[Playfair_Display] text-3xl font-semibold">Support</h1>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
              Hilfe zur Nutzung der Business Studio Suite, zur Anmeldung sowie zu Kontozugang und Datenlöschung.
            </p>
          </div>
          <Link to="/app" className="rounded-full border border-slate-300 bg-white px-4 py-2 text-sm text-slate-700 hover:bg-slate-50">
            Zur Anmeldung
          </Link>
        </header>

        <article className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <h2 className="font-[Playfair_Display] text-2xl font-semibold text-slate-900">Kontakt</h2>
          <p className="mt-3 text-sm leading-7 text-slate-700">
            Schreibe an{" "}
            <a className="underline" href="mailto:info@femmesmarketing.com?subject=Business%20Studio%20Suite%20Support">info@femmesmarketing.com</a>.
          </p>
          <p className="mt-3 text-sm leading-7 text-slate-700">
            Bitte beschreibe kurz, welchen Bereich du nutzt und was passiert ist. Sende keine Zugangsdaten oder vertraulichen Kundendaten per E-Mail.
          </p>

          <div className="mt-7 border-t border-slate-200 pt-6">
            <h2 className="font-[Playfair_Display] text-2xl font-semibold text-slate-900">Konto löschen</h2>
            <p className="mt-3 text-sm leading-7 text-slate-700">
              Den Selbstlöschweg findest du unter{" "}
              <Link className="underline" to="/konto-loeschen">Konto und Daten löschen</Link>.
            </p>
          </div>
        </article>
      </div>
    </main>
  );
};

export default SupportPage;
